(function (root) {
  'use strict';

  function dateKey(date) {
    function pad(value) {
      return String(value).padStart(2, '0');
    }

    return date.getUTCFullYear() + '-' +
      pad(date.getUTCMonth() + 1) + '-' +
      pad(date.getUTCDate());
  }

  function addFixedHoliday(dates, year, monthIndex, day) {
    var actual = new Date(Date.UTC(year, monthIndex, day, 12));
    var observed = new Date(actual.getTime());

    dates.push(dateKey(actual));

    if (actual.getUTCDay() === 6) {
      observed.setUTCDate(observed.getUTCDate() - 1);
    }

    if (actual.getUTCDay() === 0) {
      observed.setUTCDate(observed.getUTCDate() + 1);
    }

    dates.push(dateKey(observed));
  }

  function addNthWeekday(dates, year, monthIndex, weekday, occurrence) {
    var first = new Date(Date.UTC(year, monthIndex, 1, 12));
    var day = 1 +
      ((weekday - first.getUTCDay() + 7) % 7) +
      ((occurrence - 1) * 7);

    dates.push(dateKey(new Date(Date.UTC(year, monthIndex, day, 12))));
  }

  function addLastWeekday(dates, year, monthIndex, weekday) {
    var last = new Date(Date.UTC(year, monthIndex + 1, 0, 12));
    var day = last.getUTCDate() -
      ((last.getUTCDay() - weekday + 7) % 7);

    dates.push(dateKey(new Date(Date.UTC(year, monthIndex, day, 12))));
  }

  function buildUsFederalHolidayDates() {
    var dates = [];
    var currentYear = new Date().getUTCFullYear();

    for (var year = currentYear - 1; year <= currentYear + 3; year += 1) {
      addFixedHoliday(dates, year, 0, 1);
      addNthWeekday(dates, year, 0, 1, 3);
      addNthWeekday(dates, year, 1, 1, 3);
      addLastWeekday(dates, year, 4, 1);
      addFixedHoliday(dates, year, 5, 19);
      addFixedHoliday(dates, year, 6, 4);
      addNthWeekday(dates, year, 8, 1, 1);
      addNthWeekday(dates, year, 9, 1, 2);
      addFixedHoliday(dates, year, 10, 11);
      addNthWeekday(dates, year, 10, 4, 4);
      addFixedHoliday(dates, year, 11, 25);
    }

    return Array.from(new Set(dates)).sort();
  }

  /*
   * IMPORTANT
   * These values were populated from Display Zone's reviewed vendor delivery worksheet.
   * Only profiles explicitly marked enabled in that worksheet display an estimate.
   *
   * Business-day values should be whole numbers:
   * - preparation: order placed to the carrier's first acceptance scan
   * - transit: first carrier acceptance scan to delivery
   *
   * Every vendor profile can use the optional note field. The note appears
   * beneath the estimated date. Use note: '' when no message is needed.
   */
  root.DisplayZoneDeliveryConfig = {
    version: '1.5.0',
    debug: false,
    defaultLocale: 'en-US',
    defaultTimeZone: 'America/Chicago',
    defaultCutoffTimeLocal: '12:00',
    defaultShippingWeekdays: [1, 2, 3, 4, 5],
    defaultDeliveryWeekdays: [1, 2, 3, 4, 5, 6],
    supportedCountryCodes: ['US'],
    globalExcludedDates: buildUsFederalHolidayDates(),
    includeYearInDisplayedRange: false,
    text: {
      label: 'Estimated delivery',
      defaultNote: ''
    },

    profiles: {
      'perfect-cases': {
        enabled: true,
        vendorNames: ['Perfect Cases'],
        preparationMinBusinessDays: 3,
        preparationMaxBusinessDays: 5,
        transitMinBusinessDays: 2,
        transitMaxBusinessDays: 4,
        extraBufferBusinessDays: 0,
        cutoffTimeLocal: '12:00',
        timeZone: 'America/New_York',
        shippingWeekdays: [1, 2, 3, 4, 5],
        excludedDates: [],
        handmade: true,
        note: ''
      },

      'sfdisplay': {
        enabled: true,
        vendorNames: ['SFDisplay', 'SF Display', 'SFDisplay.com'],
        preparationMinBusinessDays: 1,
        preparationMaxBusinessDays: 2,
        transitMinBusinessDays: 2,
        transitMaxBusinessDays: 3,
        extraBufferBusinessDays: 0,
        cutoffTimeLocal: '12:00',
        timeZone: 'America/Los_Angeles',
        shippingWeekdays: [1, 2, 3, 4, 5],
        excludedDates: [],
        handmade: false,
        note: ''
      },

      'pennzoni-display': {
        enabled: true,
        vendorNames: ['Pennzoni Display', 'Pennzoni', 'Penzoni'],
        preparationMinBusinessDays: 1,
        preparationMaxBusinessDays: 2,
        transitMinBusinessDays: 2,
        transitMaxBusinessDays: 3,
        extraBufferBusinessDays: 0,
        cutoffTimeLocal: '12:00',
        timeZone: 'America/Detroit',
        shippingWeekdays: [1, 2, 3, 4, 5],
        excludedDates: [],
        handmade: false,
        note: ''
      },

      'better-display-cases': {
        enabled: true,
        vendorNames: ['Better Display Cases', 'Better Displays'],
        preparationMinBusinessDays: 1,
        preparationMaxBusinessDays: 2,
        transitMinBusinessDays: 2,
        transitMaxBusinessDays: 3,
        extraBufferBusinessDays: 0,
        cutoffTimeLocal: '12:00',
        timeZone: 'America/New_York',
        shippingWeekdays: [1, 2, 3, 4, 5],
        excludedDates: [],
        handmade: false,
        note: ''
      },

      'plastics-unlimited': {
        enabled: true,
        vendorNames: ['Plastics Unlimited'],
        preparationMinBusinessDays: 1,
        preparationMaxBusinessDays: 2,
        transitMinBusinessDays: 2,
        transitMaxBusinessDays: 3,
        extraBufferBusinessDays: 0,
        cutoffTimeLocal: '12:00',
        timeZone: 'America/Detroit',
        shippingWeekdays: [1, 2, 3, 4, 5],
        excludedDates: [],
        handmade: false,
        note: ''
      },

      'slab-museum': {
        enabled: false,
        vendorNames: ['Slab Museum'],
        preparationMinBusinessDays: null,
        preparationMaxBusinessDays: null,
        transitMinBusinessDays: null,
        transitMaxBusinessDays: null,
        extraBufferBusinessDays: 0,
        cutoffTimeLocal: '12:00',
        timeZone: '',
        shippingWeekdays: [1, 2, 3, 4, 5],
        excludedDates: [],
        handmade: false,
        note: ''
      },

      'hideit-mounts': {
        enabled: false,
        vendorNames: ['HIDEit Mounts', 'HIDEit'],
        preparationMinBusinessDays: null,
        preparationMaxBusinessDays: null,
        transitMinBusinessDays: null,
        transitMaxBusinessDays: null,
        extraBufferBusinessDays: 0,
        cutoffTimeLocal: '12:00',
        timeZone: '',
        shippingWeekdays: [1, 2, 3, 4, 5],
        excludedDates: [],
        handmade: false,
        note: ''
      },

      'display-zone': {
        enabled: true,
        vendorNames: ['Display Zone'],
        preparationMinBusinessDays: 1,
        preparationMaxBusinessDays: 2,
        transitMinBusinessDays: 2,
        transitMaxBusinessDays: 3,
        extraBufferBusinessDays: 0,
        cutoffTimeLocal: '12:00',
        timeZone: 'America/Chicago',
        shippingWeekdays: [1, 2, 3, 4, 5],
        excludedDates: [],
        handmade: false,
        note: ''
      }
    }
  };
})(typeof globalThis !== 'undefined' ? globalThis : window);
